import {useNavigate} from "react-router-dom";
import {isPc, sendRequest} from "../static/js/common";
import {useEffect, useState} from "react";

const Menu = ({title, navi, marginLeft}) => {

  const navigate = useNavigate();
  const [hover, setHover] = useState(false);

  return (
    <div
      className={`white bebas-kai ${marginLeft ? 'margin-left' : ''} font-2_2vw ${hover ? 'red' : ''}`}
      onClick={() => navigate(navi)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {title}
    </div>
  )
}


export const Footer = ({}) => {

  const navigate = useNavigate();
  const [brochureUrl, setBrochureUrl] = useState("");

  const getBrochure = () => {
    sendRequest('config/config/?key=BROCHURE', 'GET', null, data => {
      setBrochureUrl(data?.[0]?.file)
    })
  }

  useEffect(() => {
    getBrochure()
  }, [])

  return (
    <div className={'footer'}>
      {isPc ?
        <div className={'flex-row-wo-center'}>
          <div className={'flex-1 flex-column'} style={{padding: '2vw', paddingBottom: '4vw'}}>
            <img style={{width: '10vw'}} src={require('../assets/images/logo.png')}/>
            <div className={'white font-14 margin-top-20'} style={{lineHeight: 1.8}}>
              서울시 강남구 테헤란로 534 글라스타워 30층
            </div>
            <div className={'white font-14 margin-top-10'} style={{lineHeight: 1.8}}>
              대표 노윤철 | 통신판매업 신고번호 2024-서울강남-01232 | 사업자번호 560-85-02114 | TEL 02-560-0600
            </div>
            <div className={'blur-white font-14 margin-top-40'}>
              Copyright 2012 - 2023 PHOENIX  ⓒ All Rights Reserved.
            </div>
          </div>

          <div className={'margin-top-40 flex-column'}>
            <div className={''} style={{paddingRight: '2vw'}}>
              <div className={'flex-row-wo-center'}>
                <Menu title={'WORKS'} navi={'/works'}/>
                <Menu title={'SERVICE'} navi={'/service'} marginLeft/>
                <Menu title={'CONTACT'} navi={'/contact'} marginLeft/>
                <Menu title={'CAREERS'} navi={'/career'} marginLeft/>
                <div className={'brochure flex-row margin-left notosans-bold'} onClick={() => window.open(brochureUrl)}>
                  <img className={'icon-24'} style={{marginRight: 8}} src={require('../assets/images/download.png')}/>
                  회사 소개서 다운로드
                </div>
              </div>
            </div>
            {/*<div className={'relative margin-top-54 align-end'} onClick={() => navigate('/contact')}>*/}
            {/*  <div className={'absolute white bold notosans-black font-24'} style={{right: 'calc(30vw - 86px)', bottom: '1vw'}}>문의하기</div>*/}
            {/*  <img style={{width: '30vw'}} src={require('../assets/images/footer_line.png')}/>*/}
            {/*</div>*/}
          </div>
        </div>
        :
        <div className={'width-100 black-bg'} style={{padding: '40px 14vw 40px 3vw', marginBottom: -5}}>
          <div className={'flex-row'}>
            <div className={'flex-1'}>
              <img style={{width: '25vw'}} src={require('../assets/images/logo.png')}/>
            </div>
            <div className={'flex-end flex-column'} style={{marginTop: '2vw'}}>
              <div className={'flex-end'} style={{paddingRight: '10vw'}} onClick={() => window.open(brochureUrl)}>
                <div className={'mobile-brochure flex-row margin-left notosans-bold'}
                     onClick={() => window.open(brochureUrl)}>
                  <img className={'icon-20'} style={{marginRight: 8}} src={require('../assets/images/download.png')}/>
                  회사 소개서 다운로드
                </div>
              </div>
            </div>
          </div>
          <div className={'white font-10 margin-top-20'} style={{lineHeight: 1.8}}>
            서울시 강남구 테헤란로 534 글라스타워 30층<br/>
            대표 노윤철 | 통신판매업 신고번호 2024-서울강남-01232<br/> 사업자번호 560-85-02114 | TEL 02-560-0600
            <div className={'more-blur-white font-10 margin-top-10'} style={{paddingRight: '10vw'}}>
              Copyright 2012 - 2023 PHOENIX ⓒ All Rights Reserved.
            </div>
          </div>

          {/*<div className={'flex-end'} onClick={() => navigate('/contact')} style={{paddingRight: '3vw', marginTop: '25vw'}}>*/}
          {/*  <img style={{width: '80vw'}} src={require('../assets/images/bottom_contact.png')}/>*/}
          {/*</div>*/}
        </div>
      }
    </div>
  )
}
